export default "__VITE_PUBLIC_ASSET__3f4d431f__"